import React from 'react'
import styled from 'styled-components'
import Colors from 'components/styles/colors'
import CardPriceIconWrapper from 'components/shared/CardPriceIconWrapper'
import ReputationStar from 'components/shared/ReputationStar'

const Container = styled.div`
  padding: 12px;
`
const Head = styled.div`
  display: table;
  table-layout: fixed;
  width: 100%;
`
const HeadThumbnail = styled.div`
  display: table-cell;
  width: 56px;
  height: 56px;
  background-image: url(${props => props.url});
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center;
`
const HeadText = styled.div`
  display: table-cell;
  padding-left: 8px;
`
const HeadTextTitle = styled.h2`
  font-size: 14px;
  color: ${Colors.black};
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`
const PriceContainer = styled.div`
  display: table;
  table-layout: fixed;
  margin-top: 7px;
  line-height: 1;
`
const HeadTextPrice = styled.span`
  display: table-cell;
  color: ${Colors.black};
  font-size: 16px;
  font-weight: bold;
`
const InfoText = styled.p`
  margin-top: 6px;
  color: ${Colors.black};
  font-size: 11px;
  line-height: 1;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`
const InfoList = styled.ul`
  margin-top: 5px;
`
const InfoListItem = styled.li`
  display: inline-block;

  &:not(:first-of-type) {
    margin-left: 8px;
  }
`
const TextIcon = styled.i`
  margin-right: 5px;
  color: ${Colors.grayD};
  font-size: 12px;
`
const IconText = styled.span`
  color: ${Colors.black};
  font-size: 11px;
  line-height: 1;
`
const IconTextStar = styled.span`
  margin-left: 3px;
  color: ${Colors.black};
  font-size: 11px;
  line-height: 1;
`
const ReviewText = styled.div`
  height: 12px;
  margin-top: 8px;
  color: ${Colors.black};
  font-size: 11px;
  overflow: hidden;
`
const ViewDetailContainer = styled.div`
  margin-top: 6px;
  text-align: right;
`
const ViewDetailLink = styled.a`
  color: ${Colors.blue};
  font-size: 12px;
  line-height: 1;
  &:hover {
    text-decoration: underline;
  }
`

type PropTypes = {
  name: string,
  capacity: number,
  thumbnail: string,
  reputationScore: number,
  reputationCount: number,
  address: string,
  access: string,
  price: string,
  priceUnit: string,
  onRef: Function,
  isDirectReservation: boolean,
  isTopHost: boolean,
  isLastMinutesDiscount: boolean,
}

export default (props: PropTypes) => (
  <Container innerRef={props.onRef}>
    <Head>
      <HeadThumbnail url={props.thumbnail} />
      <HeadText>
        <HeadTextTitle>{props.name}</HeadTextTitle>
        <PriceContainer>
          <HeadTextPrice>
            {i18n.t('page.search.price', {
              price: props.price,
              unit: props.priceUnit,
            })}
          </HeadTextPrice>
          <CardPriceIconWrapper
            isDirectReservation={props.isDirectReservation}
            isTopHost={props.isTopHost}
            isLastMinutesDiscount={props.isLastMinutesDiscount}
            size="medium"
          />
        </PriceContainer>
        <InfoList>
          <InfoListItem>
            <TextIcon className="fa fa-user" />
            <IconText>
              {i18n.t('page.room.capacity', { capacity: props.capacity })}
            </IconText>
          </InfoListItem>
          <InfoListItem>
            <ReputationStar
              link=""
              score={props.reputationScore}
              size="small"
            />
            <IconTextStar>
              {i18n.t('page.room.numberOf', { count: props.reputationCount })}
            </IconTextStar>
          </InfoListItem>
        </InfoList>
      </HeadText>
    </Head>
    <div>
      <ReviewText>
        <TextIcon className="fa fa-map-marker" />
        {props.address}
      </ReviewText>
      <InfoText>{props.access}</InfoText>
      <ViewDetailContainer>
        <ViewDetailLink
          href={props.roomLink}
          onClick={e => {
            e.preventDefault()
            window.open(props.roomLink, '_blank')
          }}
        >
          {i18n.t('page.search.viewDetail')}
        </ViewDetailLink>
      </ViewDetailContainer>
    </div>
  </Container>
)



// WEBPACK FOOTER //
// ./src/components/molecules/RoomMedia/index.jsx